import { palette } from 'app_previous/styles/colors';
import { layout } from 'app_previous/styles/layout';
import styled from 'styled-components';

export const InlineInputGroupContainer = styled.div`
  position: relative;
  z-index: 3;
  width: 100%;
  max-width: 730px;
  justify-self: center;
  display: grid;
  align-items: center;
  grid-row-gap: 1.7rem;

  > p {
    margin-top: 10px;

    @media screen and (max-width: ${layout.sm}) {
      max-width: 300px;
      margin: 1rem auto 0;
    }
  }

  > button {
    width: 100%;
    margin: 1.6rem auto 0;
    max-width: 400px;
    display: none;

    @media screen and (max-width: ${layout.sm}) {
      display: flex;
      margin-top: 1rem;
    }
  }
`;

export const Divider = styled.div`
  margin: 0 auto;
  max-width: 220px;
  border-top: 1px solid ${palette.lightGrayBright};
  background-color: ${palette.lightGrayBright};
  height: 0;
  width: 100%;
`;

export const NameSuggestionsContainer = styled.div`
  display: grid;
  grid-row-gap: 1.5rem;
  padding: 0;

  #load-more-button {
    max-width: 150px;
    margin: 0 auto;
    font-size: 1.125rem;
  }
`;

export const NameSuggestionList = styled.div`
  display: grid;
  grid-row-gap: 0.5rem;
  width: 100%;
`;
